import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { map, catchError } from 'rxjs/operators';
import { Module } from '../models/module.model';


const BASE_ULR = environment.base_url;

@Injectable({
    providedIn: 'root'
})
export class ModuleService {

    constructor(
        private http: HttpClient
    ) { }

    getModules() {
        const token = localStorage.getItem('token') || '';

        return this.http.get(`${BASE_ULR}/modules`, {
            headers: {
                'X-Amz-Security-Token': token
            }
        }).pipe(
            map((resp: { modules: Module[] }) => resp.modules)
        );

    }

    create(formData) {
        const token = localStorage.getItem('token') || '';

        return this.http.post(`${BASE_ULR}/module`, formData, {
            headers: {
                'X-Amz-Security-Token': token
            }
        })
    }
}
